import type { UseFormReturn } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";
import { useParams } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import { z } from "zod";

const updateUserPasswordFormSchema = z.object({
  confirmPassword: z.string().min(1, "Please fill in this field."),
  password: z.string().min(1, "Please fill in this field."),
  userId: z.number().min(1, "UserId is required"),
});

export type UpdateUserPasswordFormData = z.infer<
  typeof updateUserPasswordFormSchema
>;

export function useUpdateUserPasswordForm(): UseFormReturn<UpdateUserPasswordFormData> {
  const { userId } = useParams({
    from: "/_auth/_app-shell/users/$userId/edit",
  });

  return useForm<UpdateUserPasswordFormData>({
    defaultValues: {
      confirmPassword: "",
      password: "",
      userId: Number(userId),
    },
    resolver: zodResolver(updateUserPasswordFormSchema),
  });
}
